






























import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import TabMenu from '@/components/common/TabMenu.vue';
@Component({
  components: {
    AdminIframe,
    TabMenu,
  },
})
export default class CouponSettingIframe extends Vue {
  private title = '할인쿠폰 설정';

  private remoteSrc = '';
  
  private setRemoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
  
  
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + '/promotion/basic/coupon-setting?' + queryString;
  }
  
  created() {
    this.setRemoteSrc();
  }
}
